var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('audio',{ref:"audio",staticClass:"audio_player",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.url,"type":"audio/mpeg"}}),_c('source',{attrs:{"src":_vm.url,"type":"audio/mp3"}}),_c('source',{attrs:{"src":_vm.url,"type":"audio/ogg"}}),_vm._v(" 您的浏览器不支持 audio 标签。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }